import styled from "styled-components";

const StyledViewerHead = styled.div`
  position: relative;
  padding: 140px 64px 0;
  @media screen and (max-width: 1439px){
    padding: 120px 40px 0;
  }
  @media screen and (max-width: 1023px){
    padding: 100px 24px 0;
  }
  p {
    color: #a8a8a8;
    padding-bottom: 20px;
  }
  h6 {
    padding-bottom: 24px;
  }
`;

const StyledViewerWrap = styled.div`
  position: relative;
  padding: 0 64px;
  margin-bottom: 64px;
  @media screen and (max-width: 1439px){
    padding: 0 40px;
  }
  @media screen and (max-width: 1023px){
    padding: 0 24px;
    margin-bottom: 40px;
  }
  .blue {
    color: #48777d;
  }
  .viewer-content {
    position: relative;
    width: 80%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin: 0 auto;
    .iframe-wrap {
      position: relative;
      flex: 0 0 65%;
      height: auto;
      align-self: stretch;
      iframe {
        position: relative;
        width: 100%;
        border: none;
        height: 100%;
        @media screen and (max-width: 1023px){
          position: relative;
          width: 100%;
          height: 350px;
        }
      }
    }
    .viewer-text {
      position: relative;
      flex: 0 0 35%;
      padding-left: 20px;
      .viewer-row{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 24px;
        img {
          flex: 0 0 40%;
          max-width: 100px;
          margin-right: 20px;
        }
        .color-mod {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          margin-right: 10px;
          cursor: pointer;
          span {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            margin: 3px auto 0;
            display: block;
          }
          &.color-light {
            span {
              background-color: #91201a;
            }
          }
          &.color-brown{
            span {
              background-color: #c4b29c;
            }
          }
          &.color-black{
            span {
              background-color: #000;
            }
          }
          &.selected {
            border: 1px solid #426d74;
          }
        }
      }
      @media screen and (max-width: 1023px){
        padding-left: 0;
      }
    }
    @media screen and (max-width: 1023px){
      width: 100%;
      flex-direction: column;
      .iframe-wrap, .viewer-text {
        flex: 0 0 100%;
        width: 100%;
      }
      .iframe-wrap {
        margin-bottom: 40px;
      }
    }
  }
  .arrow-wrap{
    position: absolute;
    width: 40px;
    top: 50%;
    cursor: pointer;
    z-index: 4;
    img {
      display: block;
      width: 100%;
    }
    &.prev {
      left: -50px;
      transform: translate(-100%, -50%);
      @media screen and (max-width: 1023px){
        top: 0;
        left: 0;
        transform: translate(0%, 50%);
      }
    }
    &.next {
      right: -50px;
      transform: translate(100%, -50%);
      @media screen and (max-width: 1023px){
        top: 0;
        right: 0;
        transform: translate(0%, 50%);
      }
    }
  }
`;


export {
  StyledViewerHead,
  StyledViewerWrap
}